export interface GuideArticle {
  slug: string;
  title: string;
  desc: string;
  category: string;
  readTime: number;
  date: string;
  image: string;
}

export const guideArticles: GuideArticle[] = [
  {
    slug: "allchinabuy-spreadsheet-guide",
    title: "AllChinaBuy Spreadsheet",
    desc: "Discover products, categories and seller resources.",
    category: "Spreadsheet",
    readTime: 8,
    date: "2026-08-20",
    image: "https://readdy.ai/api/search-image?query=Laptop%20with%20product%20spreadsheet%20on%20screen%20beside%20colorful%20fashion%20items%20on%20clean%20desk%2C%20soft%20natural%20light%2C%20minimal%20workspace%20photography%2C%20warm%20neutral%20tones&width=600&height=400&seq=art-spreadsheet&orientation=landscape"
  },
  {
    slug: "allchinabuy-review",
    title: "AllChinaBuy Review",
    desc: "Understand the platform, features, buying process and important considerations.",
    category: "Review",
    readTime: 6,
    date: "2026-08-18",
    image: "https://readdy.ai/api/search-image?query=Smartphone%20showing%20online%20shopping%20app%20with%20product%20reviews%20on%20light%20surface%2C%20soft%20studio%20light%2C%20minimal%20ecommerce%20review%20concept%20photography%2C%20clean%20editorial%20style&width=600&height=400&seq=art-review&orientation=landscape"
  },
  {
    slug: "allchinabuy-shipping",
    title: "AllChinaBuy Shipping Cost",
    desc: "Learn about shipping methods, pricing factors, delivery times and ways to reduce unnecessary costs.",
    category: "Shipping",
    readTime: 7,
    date: "2026-08-15",
    image: "https://readdy.ai/api/search-image?query=Stacked%20parcel%20boxes%20with%20shipping%20labels%20on%20light%20grey%20table%2C%20soft%20warm%20light%2C%20minimal%20logistics%20photography%2C%20clean%20commercial%20style&width=600&height=400&seq=art-shipping&orientation=landscape"
  },
  {
    slug: "allchinabuy-warehouse",
    title: "AllChinaBuy Warehouse",
    desc: "Understand warehouse storage, QC photos, parcel preparation and shipping workflow.",
    category: "Warehouse",
    readTime: 5,
    date: "2026-08-12",
    image: "https://readdy.ai/api/search-image?query=Organized%20warehouse%20shelving%20with%20labeled%20boxes%20in%20clean%20rows%2C%20warm%20industrial%20light%2C%20minimal%20storage%20facility%20photography%2C%20clean%20logistics%20aesthetic&width=600&height=400&seq=art-warehouse&orientation=landscape"
  },
  {
    slug: "allchinabuy-coupon",
    title: "AllChinaBuy Coupon",
    desc: "Find current coupon information and understand how discounts may work.",
    category: "Coupons",
    readTime: 4,
    date: "2026-08-10",
    image: "https://readdy.ai/api/search-image?query=Colorful%20discount%20coupons%20with%20scissors%20on%20light%20beige%20surface%2C%20soft%20warm%20light%2C%20minimal%20promotion%20concept%20photography%2C%20clean%20commercial%20style&width=600&height=400&seq=art-coupon&orientation=landscape"
  },
  {
    slug: "allchinabuy-legit",
    title: "AllChinaBuy Legit",
    desc: "Learn how to evaluate platform legitimacy, seller reliability and common buying risks.",
    category: "Safety",
    readTime: 6,
    date: "2026-08-08",
    image: "https://readdy.ai/api/search-image?query=Green%20shield%20checkmark%20icon%20on%20light%20grey%20surface%2C%20soft%20studio%20light%2C%20minimal%20trust%20verification%20concept%20photography%2C%20clean%20editorial%20style&width=600&height=400&seq=art-legit&orientation=landscape"
  },
  {
    slug: "allchinabuy-qc",
    title: "AllChinaBuy QC",
    desc: "Understand QC photos, product checks and what to review before shipping.",
    category: "QC",
    readTime: 6,
    date: "2026-08-05",
    image: "https://readdy.ai/api/search-image?query=Magnifying%20glass%20inspecting%20sneaker%20detail%20on%20light%20neutral%20surface%2C%20soft%20warm%20light%2C%20minimal%20quality%20control%20concept%20photography%2C%20clean%20commercial%20style&width=600&height=400&seq=art-qc&orientation=landscape"
  },
  {
    slug: "allchinabuy-shipping-cost",
    title: "AllChinaBuy Shipping Cost",
    desc: "Understand shipping rates, methods, weight factors and how to estimate costs.",
    category: "Shipping",
    readTime: 6,
    date: "2026-08-25",
    image: "https://readdy.ai/api/search-image?query=Calculator%20and%20shipping%20box%20with%20price%20tag%20on%20light%20grey%20desk%2C%20soft%20studio%20light%2C%20minimal%20shipping%20cost%20concept%20photography%2C%20clean%20commercial%20style&width=600&height=400&seq=art-shipping-cost&orientation=landscape"
  },
  {
    slug: "allchinabuy-discount-code",
    title: "AllChinaBuy Discount Code",
    desc: "Find current discount codes and learn how to verify offers before use.",
    category: "Coupons",
    readTime: 5,
    date: "2026-08-24",
    image: "https://readdy.ai/api/search-image?query=Promo%20code%20card%20with%20percent%20symbol%20on%20light%20cream%20surface%20with%20small%20gift%20box%2C%20soft%20warm%20light%2C%20minimal%20discount%20concept%20photography%2C%20clean%20editorial%20style&width=600&height=400&seq=art-discount-code&orientation=landscape"
  },
  {
    slug: "allchinabuy-sellers",
    title: "AllChinaBuy Sellers",
    desc: "Learn how to identify trusted sellers and avoid unreliable vendors.",
    category: "Sellers",
    readTime: 7,
    date: "2026-08-23",
    image: "https://readdy.ai/api/search-image?query=Small%20business%20storefront%20with%20product%20shelves%20and%20warm%20lighting%20on%20light%20neutral%20background%2C%20soft%20natural%20light%2C%20minimal%20seller%20shop%20concept%20photography%2C%20clean%20commercial%20style&width=600&height=400&seq=art-sellers&orientation=landscape"
  },
  {
    slug: "allchinabuy-comparison",
    title: "AllChinaBuy Comparison",
    desc: "Compare AllChinaBuy with other agents across key dimensions.",
    category: "Comparison",
    readTime: 8,
    date: "2026-08-22",
    image: "https://readdy.ai/api/search-image?query=Two%20columns%20comparison%20chart%20with%20checkmarks%20and%20product%20icons%20on%20light%20surface%2C%20soft%20studio%20light%2C%20minimal%20comparison%20concept%20photography%2C%20clean%20editorial%20style&width=600&height=400&seq=art-comparison&orientation=landscape"
  },
  {
    slug: "allchinabuy-buying-guide",
    title: "AllChinaBuy Buying Guide",
    desc: "A step-by-step guide from product search to final delivery.",
    category: "Guide",
    readTime: 9,
    date: "2026-08-21",
    image: "https://readdy.ai/api/search-image?query=Shopping%20bags%20and%20colorful%20fashion%20items%20with%20checklist%20on%20light%20neutral%20surface%2C%20soft%20warm%20light%2C%20minimal%20shopping%20guide%20concept%20photography%2C%20clean%20commercial%20style&width=600&height=400&seq=art-buying-guide&orientation=landscape"
  },
  {
    slug: "allchinabuy-beginner",
    title: "AllChinaBuy for Beginners",
    desc: "Everything first-time buyers need to know before their first order.",
    category: "Guide",
    readTime: 7,
    date: "2026-08-19",
    image: "https://readdy.ai/api/search-image?query=Open%20guidebook%20with%20step%20numbers%20and%20small%20shopping%20items%20on%20light%20desk%2C%20soft%20natural%20light%2C%20minimal%20beginner%20guide%20concept%20photography%2C%20clean%20editorial%20style&width=600&height=400&seq=art-beginner&orientation=landscape"
  },
  {
    slug: "allchinabuy-payment",
    title: "AllChinaBuy Payment Guide",
    desc: "Understand payment methods, stages and safety best practices.",
    category: "Guide",
    readTime: 5,
    date: "2026-08-17",
    image: "https://readdy.ai/api/search-image?query=Credit%20card%20and%20smartphone%20with%20payment%20screen%20on%20light%20grey%20surface%2C%20soft%20studio%20light%2C%20minimal%20online%20payment%20concept%20photography%2C%20clean%20commercial%20style&width=600&height=400&seq=art-payment&orientation=landscape"
  },
  {
    slug: "allchinabuy-refund",
    title: "AllChinaBuy Refund Guide",
    desc: "Learn how returns, disputes and refunds work on the platform.",
    category: "Guide",
    readTime: 5,
    date: "2026-08-16",
    image: "https://readdy.ai/api/search-image?query=Return%20box%20with%20arrow%20and%20receipt%20on%20light%20neutral%20surface%2C%20soft%20warm%20light%2C%20minimal%20refund%20concept%20photography%2C%20clean%20commercial%20style&width=600&height=400&seq=art-refund&orientation=landscape"
  },
  {
    slug: "allchinabuy-parcel",
    title: "AllChinaBuy Parcel Guide",
    desc: "Packaging, consolidation and protection tips for international shipping.",
    category: "Shipping",
    readTime: 6,
    date: "2026-08-14",
    image: "https://readdy.ai/api/search-image?query=Wrapped%20parcel%20with%20bubble%20wrap%20and%20packing%20tape%20on%20light%20grey%20table%2C%20soft%20studio%20light%2C%20minimal%20packaging%20concept%20photography%2C%20clean%20commercial%20style&width=600&height=400&seq=art-parcel&orientation=landscape"
  },
  {
    slug: "allchinabuy-safety-guide",
    title: "AllChinaBuy Safety Guide",
    desc: "Avoid scams, protect your account and buy with confidence.",
    category: "Safety",
    readTime: 7,
    date: "2026-08-13",
    image: "https://readdy.ai/api/search-image?query=Shield%20lock%20and%20padlock%20on%20light%20cream%20surface%2C%20soft%20warm%20light%2C%20minimal%20safety%20security%20concept%20photography%2C%20clean%20editorial%20style&width=600&height=400&seq=art-safety-guide&orientation=landscape"
  }
];